import { render, staticRenderFns } from "./CardHumor.vue?vue&type=template&id=77b9b3f3&scoped=true"
import script from "./CardHumor.vue?vue&type=script&lang=js"
export * from "./CardHumor.vue?vue&type=script&lang=js"
import style0 from "./CardHumor.vue?vue&type=style&index=0&id=77b9b3f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b9b3f3",
  null
  
)

export default component.exports